export const disableEnterSubmit = (el) => {
  el.addEventListener("keydown", function (event) {
    // Allow Enter in textareas
    if (event.key === "Enter" && event.target.tagName === "TEXTAREA") {
      return;
    }

    // Prevent form submission on Enter for all other elements
    if (event.key === "Enter") {
      event.preventDefault();
    }
  });
};
